import { Fragment, useState } from 'react';
import { Trans } from '@lingui/react/macro';
import { Button } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { SaveViewDialog } from './SaveViewDialog';
export function SaveViewButton() {
    const [open, setOpen] = useState(false);
    return (<Fragment>
      <Button type="button" size="xs" onClick={() => setOpen(true)} appearance="secondary">
        <Falcon icon="layer-plus"/>
        <Trans comment="Save view button label" context="all-documents">
          Save view
        </Trans>
      </Button>
      {open && <SaveViewDialog onClose={() => setOpen(false)}/>}
    </Fragment>);
}
